import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import UpgradeArrowNewNav from './icon-upgrade-arrow-new-nav.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <UpgradeArrowNewNav {...validProps} />;
}
SvgComponent.iconName = 'upgradeArrowNewNav';

/**
 * @deprecated This is a legacy icon
 */
export const UpgradeArrowIconNewNav = svgIconWrapper(SvgComponent);
